// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import infoIcon from './info-icon.svg';

export function UpiIdInfo(): Node {
  return (
    <Root>
      <IconWrapper>
        <Icon src={infoIcon} alt="info icon"/>
      </IconWrapper>
      <Info>
        This transaction must be confirmed in your UPI app.
      </Info>
    </Root>
  );
}

const Root = styled.div `
  background: ${props => props.theme.colors.new_primary[50]};
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 8px;
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
  color: #fff;
`;

const IconWrapper = styled.div`
  background: #007ace;
  display: inline-block;
  margin-right: 16px;
  padding: 5px;
  border-radius: 8px;

  width: 32px;
  height: 32px;
`;

const Info = styled.div`
  font-size: 13px;
  line-height: 21px;
  color: ${props => props.theme.colors.neutral[900]};
  width: 100%;
  display: inline-block;
  font-family: Noto Sans, "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica, sans-serif;
`;
